/*eslint-disable */
import Vue from 'vue'
import moment from 'moment';
import VueCountdownTimer from 'vuejs-countdown-timer'
var myVar, myVar1, myVar2, myVar3;
Vue.use(VueCountdownTimer)
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import countries from '../../services/country.json';
import {
  mapGetters,
  mapState
} from 'vuex';
import { set } from 'lodash';
export default {
  name: 'quiz-contest-dashboard',
  components: {
  },
  props: [],
  data() {
    return {
      checkUserCountry: false,
      scrollLoaded: false,
      scrollHeight: 0,
      countryList: [],
      previousContestList: [],
      showResultPopup: false,
      orgLeaderList: [],
      orgLeaderCheck: false,
      quizResultList: [],
      quizContestList: {},
      filterResultfun: [],
      currentUTCDate: '',
      contestStartTime: Boolean,
      upcomingContestTime: false,
      userinfo: {},
      contestDetailsById: false,
      contestDetailsState: {
        contestName: '',
        contestId: '',
        contestStartDate: '',
        contestEndDate: '',
        contestIndex: '',
        contestStatus: false
      },
      contestDetailsByIdWithPrize:{},
      curentDate: new Date(),
      curentDateTimeZone: '',
      tmcPopup:false,
      prizAalertModal:false,
      pointsAalertModal:false,
      userProfileData:{},
      checkUserOrg:false,
      checkUserSchool:false,
      userInfoAlertPopup:false,
      earnedPointsState:'',
      leaderBoardDetails:'',
      leaderBoardList:[],
      fullCurrentDateFormatWithUtc:'',
      currentDateTimeUTC:'',
      fullCurrentDateTimeFormatWithUtc:'',
      leaderBoardTabState:'rank',
      schollLeaderList:[],
      schollLeaderCheck:false,
      instituteLoader:false,
      contestTestingRouterCheck:'',
      quizContestLoader:true,
      preQuizContestLoader:true,
      rankLoader:true,
      outSideClickCheck:false
    }
  },
  computed: {
    ...mapGetters([
      'quizContestGetters',
      'getProfileInfo',
      'contestPointsObtainedGetters',
      'contestLeaderBoardGetters'
    ]),
    ...mapState([
      'profileInfo'
    ]),
    getEarnedPointsInfo(){
      this.earnedPointsState = this.$store.getters.contestPointsObtainedGetters.data;
      return
    },
    getLeaderBoardListFun(){
      this.leaderBoardDetails = this.$store.getters.contestLeaderBoardGetters;
      return 
    },
    setInitialLeaderBoardState(){
      if(this.leaderBoardDetails.data != undefined){
        this.leaderBoardList = this.leaderBoardDetails.data
        this.rankLoader = false
      }
      return
    },
    getUserInfo() {
      this.userinfo = this.$store.state.profileStore.profileInfo.data;
      if(this.userinfo != undefined){
        this.userProfileData = this.userinfo.profile
        if(this.userProfileData.country) {
          this.checkUserCountry = true;
        }
        if(this.userProfileData != undefined){
          for(var i = 0; i < this.userProfileData.professional_info.length; i++){
              if(this.userProfileData.professional_info[i].key == 'organization'){
                if(this.userProfileData.professional_info[i].value){
                  this.checkUserOrg = true
                  // console.log(this.userProfileData.professional_info[i].value, "Check Org Value")
                }
              }else if(this.userProfileData.professional_info[i].key == 'school'){
                if(this.userProfileData.professional_info[i].value){
                  this.checkUserSchool =  true
                  // console.log(this.userProfileData.professional_info[i].value, 'Check School Value')
                }
              }
          }
        }
      }
      return
    },
    getCategory() {
      this.quizContestList = this.$store.getters.quizContestGetters.data;
      return this.quizContestList
    },
    SetIntialStatus() {
      if (this.quizContestList != undefined) {
        this.filterResultfun = this.quizContestList.results;
        this.quizContestLoader = false
      }
      return;
    },
    getRouterTestingCheckFun(){
      this.contestTestingRouterCheck = this.$route.name
    }
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    var _self = this
    $(document).ready(function () {
      $('body').addClass('contestDash');
      $('.user-dashboard').addClass('actvCollaspe');
      $(document).click(function (event) {
        //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!$(event.target).closest(".contest_left_main, .tmc_popup_wrp, .contest_userinfo_confirm_close_popup").length) {
          clearTimeout(myVar);
          clearTimeout(myVar2);
          $('.contest_left_main').removeClass('actv_contest_details_popup')
          $('.quiz_contest_popup_details').removeClass('contest_show_content')
          $('.quiz_contest_main').removeClass('overflow_content_show')
          _self.contestDetailsById = false
          _self.contestDetailsState.contestStatus = false;
          _self.contestDetailsState.contestId = ''
          _self.contestDetailsState.contestName = ''
          _self.contestDetailsState.contestStartDate = ''
          _self.contestDetailsState.contestEndDate = ''
          _self.contestDetailsState.contestIndex = ''
        }
      });
    })
    this.getUserInfo
    this.getCategory
    this.SetIntialStatus
    this.seconds_with_leading_zeros(this.curentDate)
    this.getEarnedPointsInfo
    this.getLeaderBoardListFun
    this.setInitialLeaderBoardState
    this.getRouterTestingCheckFun
    $(window).scrollTop(0);
    this.getPreviousContestList();
  },
  methods: {
    getPreviousContestList() {
      this.$store.dispatch('getQuizContestFun')
        .then((res) => {
          if(res.data.results){
            let contests = res.data.results;
            contests.sort((a, b) => (a.start_time < b.start_time) ? 1 : -1);
            this.previousContestList = contests;
            this.preQuizContestLoader = false
          }
        })
        .catch((err) => {})
    },
    showLeaderBoardTabs(tabValue){
      this.leaderBoardTabState = tabValue
      if(tabValue === 'school'){
        if(this.schollLeaderCheck === false){
          $('body').addClass('httploader_hide')
          this.instituteLoader = true
          this.$store.dispatch('getSchoolLeaderBoardListFun').then((res) => {
            this.schollLeaderCheck = true
            this.schollLeaderList = res.data
            this.instituteLoader = false
          })
        }
      }
      if(tabValue === 'organization'){
        if(this.orgLeaderCheck === false){
          $('body').addClass('httploader_hide')
          this.instituteLoader = true
          this.$store.dispatch('getOrgLeaderBoardListFun').then((res) => {
            this.orgLeaderCheck = true;
            this.orgLeaderList = res.data
            this.instituteLoader = false;
          })
        }
      }
    },
    dateFormatNumbringFun(date) {
      var d = moment(date).utc().format('DD')
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
      }
    },
    showmoreListFun(){
      var _selff = this
      this.outSideClickCheck = true
      var topScrollHeight = $('.show_more_links').offset().top;
      $('html, body').animate({ scrollTop:topScrollHeight },"slow");
      $('.contest_viewer_user_list_wrp').addClass("show_more_list_actv")
      if(this.outSideClickCheck == true){
        $(document).ready(function(){
          $(document).click(function (event) {
            if(_selff.outSideClickCheck == true){
              if (!$(event.target).closest(".contest_viewer_user_list_wrp.show_more_list_actv").length) {
                $('html, body').animate({ scrollTop:0 }, 500);
                setTimeout(() => {
                  $('.contest_viewer_user_list_wrp').removeClass("show_more_list_actv")
                }, 501);
                _selff.outSideClickCheck = false
              }
            }
          });
        })
      }
    },
    hidemoreListFun(){
      $('html, body').animate({ scrollTop:0 }, 500);
      setTimeout(() => {
        $('.contest_viewer_user_list_wrp').removeClass("show_more_list_actv")
      }, 501);
      this.outSideClickCheck = false
    },
    seconds_with_leading_zeros(dt) {
      this.curentDateTimeZone = /\((.*)\)/.exec(new Date().toString())[1]
      return this.curentDateTimeZone;
    },
    startCallBack: function (x) {
      console.log(x)
    },
    endCallBack: function (x) {
      console.log(x)
    },
    getCurrentDateWithUTC() {
         var CurrentDateFormat = this.curentDate.getDate();
         if(CurrentDateFormat<10){
            CurrentDateFormat='0'+CurrentDateFormat;
          }
         var CurrentYearFormat = this.curentDate.getFullYear();
         var CurrentMonthFormat = this.curentDate.getMonth() + 1;
         if(CurrentMonthFormat<10){
           CurrentMonthFormat='0'+CurrentMonthFormat;
         }
         this.fullCurrentDateFormatWithUtc = CurrentYearFormat + "-" + CurrentMonthFormat + "-" + CurrentDateFormat
    },
    getCurrentDateTimeWithUTC() {
         var CurrentDateFormat = this.curentDate.getDate();
         var CurrentYearFormat = this.curentDate.getFullYear();
         var CurrentMonthFormat = this.curentDate.getMonth() + 1;

         var CurrentDateHoursFormat = this.curentDate.getHours();
         var CurrentDateMinutesFormat = this.curentDate.getMinutes();
         var CurrentDateSecondFormat = this.curentDate.getSeconds();

         this.fullCurrentDateTimeFormatWithUtc = CurrentYearFormat + "-" + CurrentMonthFormat + "-" + CurrentDateFormat + '-' + CurrentDateHoursFormat + '-' + CurrentDateMinutesFormat + '-' + CurrentDateSecondFormat
    },
    getStartDateWithUpcomingContest(startTime) {
      this.getCurrentDateWithUTC()
      var StartDateFormatDate = moment(startTime).utc().format('DD');
      var StartMonthFormatDate = moment(startTime).utc().format('MM');
      var StartYearFormatDate = moment(startTime).utc().format('YYYY');
      var StartDateFormatDateWithNextDay = 1 + parseInt(StartDateFormatDate)
      var FullStartDataWithUtc = StartYearFormatDate + "-" + StartMonthFormatDate + "-" + StartDateFormatDate
      return FullStartDataWithUtc >= this.fullCurrentDateFormatWithUtc
    },
    getStartDateWithPreviousContest(startTime) {
      this.getCurrentDateWithUTC()
      var StartDateFormatDate = moment(startTime).utc().format('DD');
      var StartMonthFormatDate = moment(startTime).utc().format('MM');
      var StartYearFormatDate = moment(startTime).utc().format('YYYY');
      var StartDateFormatDateWithNextDay = 1 + parseInt(StartDateFormatDate)
      var FullStartDataWithUtc = StartYearFormatDate + "-" + StartMonthFormatDate + "-" + StartDateFormatDate
      // console.log(FullStartDataWithUtc,  this.fullCurrentDateFormatWithUtc, "Check the previous date")
      return  FullStartDataWithUtc < this.fullCurrentDateFormatWithUtc
    },
    startContestPopupBtn(contestStartTime, contestEndTime) {
      this.currentUTCDate = moment.utc().format();
      if(contestEndTime == null){
        this.getCurrentDateWithUTC()
        var StartDateFormatDate = moment(contestStartTime).utc().format('DD');
        var StartMonthFormatDate = moment(contestStartTime).utc().format('MM');
        var StartYearFormatDate = moment(contestStartTime).utc().format('YYYY');
        var FullStartDataWithUtc = StartYearFormatDate + "-" + StartMonthFormatDate + "-" + StartDateFormatDate
        return FullStartDataWithUtc === this.fullCurrentDateFormatWithUtc
      }else if (this.currentUTCDate > contestStartTime && contestEndTime > this.currentUTCDate){
        return true;
      }
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `http://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/country/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    showQuizFun() {
      $('.quiz_contest_winner_details').fadeOut(function(){
        $('.quiz_contest_popup_details').fadeIn(100);
        $('.quiz_contest_winner_details').removeClass('active');
        this.scrollLoaded = false;
      });
    },
    showFullResults(quizId) {
      let data = {
        id: quizId
      };
      var _self = this;
      this.$store.dispatch('getQuizWinnersListFun', data).then((res) => {
            this.quizResultList = res.data;
            setTimeout(function(){
              $('.quiz_contest_popup_details').fadeOut(function(){
                $('.quiz_contest_winner_details').addClass('active');
                var titleHeight = $('.winner-heading').outerHeight();
                var subTitleHeight = $('.winner-number').outerHeight();
                var popupHeight = $('.quiz_contest_winner_details').outerHeight();
                var scrollHeight = popupHeight - subTitleHeight - titleHeight - 40;
                console.log(titleHeight, subTitleHeight, popupHeight, scrollHeight);
                _self.scrollHeight = scrollHeight;
                _self.scrollLoaded = true;
              });
            },200);
        })
        .catch(function(err) {})
      return
    },
    contestDetailsPopupFun(contestId, contestName, contestStartDate, contestEndDate,contestLocalStorageData, contestIndex) {
      localStorage.setItem('contestDetails', JSON.stringify(contestLocalStorageData))
      this.contestDetailsState.contestId = contestId
      this.contestDetailsState.contestName = contestName
      this.contestDetailsState.contestStartDate = contestStartDate
      this.contestDetailsState.contestEndDate = contestEndDate
      this.contestDetailsState.contestIndex = contestIndex
      this.contestDetailsByIdWithPrize = contestLocalStorageData
      this.contestDetailsState.contestStatus = contestLocalStorageData.is_active;
      this.contestDetailsById = true
      $(window).scrollTop(0);
      $('.contest_left_main').addClass('actv_contest_details_popup')
      myVar = setTimeout(() => {
        $('.quiz_contest_popup_details').addClass('contest_show_content')
      }, 300)
      myVar2 = setTimeout(() => {
        $('.quiz_contest_main').addClass('overflow_content_show')
      }, 1400)
    },
    contestDetailsPopupClosed() {
      clearTimeout(myVar);
      clearTimeout(myVar2);
      $('.contest_left_main').removeClass('actv_contest_details_popup')
      $('.quiz_contest_popup_details').removeClass('contest_show_content')
      $('.quiz_contest_main').removeClass('overflow_content_show')
      this.contestDetailsById = false
      this.contestDetailsState.contestId = ''
      this.contestDetailsState.contestName = ''
      this.contestDetailsState.contestStartDate = ''
      this.contestDetailsState.contestEndDate = ''
      this.contestDetailsState.contestIndex = ''
      this.contestDetailsByIdWithPrize = {}
      localStorage.removeItem('contestDetails')
    },
    tmcPopupFun(){
      this.tmcPopup = true
      $('body').addClass('tmc_popup_body')
    },
    tmcPopupCloseFun(){
      this.tmcPopup = false
      $('body').removeClass('tmc_popup_body')
    },
    prizeAlertPopupShowFun(){
      $("body").addClass('contestNotificationScroll')
      this.prizAalertModal = true
    },
    closeAlertPopupShowFun(){
      this.prizAalertModal = false
      $("body").removeClass('contestNotificationScroll')
    },
    pointsAlertPopupShowFun(){
      $("body").addClass('contestNotificationScroll')
      this.pointsAalertModal = true
    },
    closePointsAlertPopupShowFun(){
      this.pointsAalertModal = false
      $("body").removeClass('contestNotificationScroll')
    },
    userInfoOrgUpdateFun(){
      this.userInfoAlertPopup = true
      $('body').addClass('commonPopupActvScrollHide')
    },
    userInfoAlertPopupClosedFun(){
      this.userInfoAlertPopup = false
      $('body').removeClass('commonPopupActvScrollHide')
    }
  },
  beforeMount() {
    this.SetIntialStatus
  },
  created (){
  },
  watch: {
    getRouterTestingCheckFun(){
      this.contestTestingRouterCheck = this.$route.name
    },
    getCategory() {
      return this.$store.getters.quizContestGetters;
    },
    getEarnedPointsInfo(){
      return this.$store.getters.contestPointsObtainedGetters
    },
    SetIntialStatus() {
      if (this.quizContestList != undefined) {
        this.filterResultfun = this.quizContestList.results;
      }
      return
    },
    getUserInfo() {
      this.userinfo = this.$store.state.profileStore.profileInfo.data;
      if(this.userinfo != undefined){
        this.userProfileData = this.userinfo.profile;
        if(this.userProfileData.country) {
          this.checkUserCountry = true;
        }
        if(this.userProfileData != undefined){
          for(var i = 0; i < this.userProfileData.professional_info.length; i++){
              if(this.userProfileData.professional_info[i].key == 'organization'){
                if(this.userProfileData.professional_info[i].value){
                  this.checkUserOrg = true
                  // console.log(this.userProfileData.professional_info[i].value, "Check Org Value")
                }
              }else if(this.userProfileData.professional_info[i].key == 'school'){
                if(this.userProfileData.professional_info[i].value){
                  this.checkUserSchool =  true
                  // console.log(this.userProfileData.professional_info[i].value, 'Check School Value')
                }
              }
          }
        }
      }
      return
    },
    getLeaderBoardListFun(){
      return this.$store.getters.contestLeaderBoardGetters;
    },
    setInitialLeaderBoardState(){
      if(this.leaderBoardDetails != undefined){
        this.leaderBoardList = this.leaderBoardDetails.data
      }
      return
    },
  },
  beforeCreate: function () {
    $('body').addClass('contestDash');
    $('.user-dashboard').addClass('actvCollaspe');
  },
  beforeRouteLeave: function (to, from, next) {
    if(from.name == 'contestTesting' && to.name == 'contest'){
      $('.user-dashboard').addClass('actvCollaspe');
      $('body').addClass('contestDash');
    }else{
    $('.user-dashboard').removeClass('actvCollaspe');
    $('body').removeClass('contestDash');
    $('body').removeClass('commonPopupActvScrollHide')
    $('body').removeClass('httploader_hide')
    }
    next();
  },
}
